<template>
	<div class="ui inline search dropdown manager-school-picker manager-school-picker-search" :class="{ loading: loading }">
		<input class="search" type="text" style="z-index: 4" v-model="searchText">
		<div class="text" style="min-width: 8em;" @click="focusInput">
			<div class="ui small header">
				<div class="content" v-if="activeSchool && !searchText">
					{{ activeSchool.title }}
					<div class="sub header"> {{ activeSchool.description }}</div>
				</div>
			</div>
		</div>
		<i class="search icon"></i>
	</div>
</template>

<script>
export default {
	props: {
		schools: {
			default: function() {
				return [];
			}
		},
		loading: {
			default: false
		},
		activeSchool: {
			default: null
		}
	},
	data: function() {
		return {
			defaultJob: null,
			searchText: ''
		};
	},
	watch: {
		schools: function(newSchools, oldSchools) {
			if(newSchools != oldSchools) {
				this.initSchools();
			}
		}
	},
	methods: {
		initSchools: function() {
			this.schools.forEach(item => {
				let jobName = item.jobName;
				if(item.jobShortCode) {
					jobName += ' - ' + item.jobShortCode;
				}

				let organizationName = item.organizationName;
				if(item.organizationShortCode) {
					organizationName += ' - ' + item.organizationShortCode;
				}

				item.title = jobName;
				item.description = organizationName;
			});

			$(this.$el).addClass('searchInit').search({
				source: this.schools,
				searchDelay: 0,
				// NOTE: This isn't supported in Semantic UI 2.2.  This working requires a monkey patch of the semantic.min.js file to replace fuzzy search with exact search on older versions:
				// fuzzySearch:function(e,t){var n=t.length,i=e.length;if("string"!=typeof e)return!1;if(e=e.toLowerCase(),t=t.toLowerCase(),i>n)return!1;
				// fuzzySearch:function(e,t){var n=t.length,i=e.length;if("string"!=typeof e)return!1;if(e=e.toLowerCase(),t=t.toLowerCase(),i>n)return!1;return t.includes(e);
				fullTextSearch: 'exact',
				searchOnFocus: true,
				minCharacters: 0,
				maxResults: 20,
				onSelect: (project) => {
					this.selectJob(project);
				},
				selector: {
					prompt: '.search'
				}
			});

			if(this.schools.length) {
				this.defaultJob = window.managerSchoolGetDefaultSchool(this.schools);
				this.selectJob(this.defaultJob);
			} else if(this.activeSchool) {
				this.selectJob(null);
			}
		},
		selectJob(school) {
			// Yearbook's tab highlight wasn't working without this since it was passing a clone of the object instead of the original
			school = this.schools.filter(function(checkSchool) {
				return school.jobId == checkSchool.jobId;
			})[0] || school;

			if(school) {
				if(!$.currentSetSeason && school != this.defaultJob) {
					this.defaultJob = school;
					window.managerSchoolSaveDefaultSchool(school);
				}
			}

			this.$emit('schoolChanged', school);
			this.searchText = '';
		},

		focusInput() {
			$(this.$el).find('input.search').focus();
		}
	},
	mounted: function() {
		$.managerSchoolDropdown = $(this.$el);

		window.selectSchoolInDropdown = (school) => {
			this.selectJob(school);
		};

		this.initSchools();
	}
};
</script>

<style scoped>

</style>